export const COLOR_FORMAT_HEX = 'Hex'

export const COLOR_FORMAT_RGB = 'RGB'

export const COLOR_FORMATS = [
  { label: COLOR_FORMAT_HEX, value: COLOR_FORMAT_HEX },
  { label: COLOR_FORMAT_RGB, value: COLOR_FORMAT_RGB },
]

export const COLOR_PICKER_DEFAULT_HEX = '#000000'
